import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useMutation } from '@apollo/client';
// Api
import { TIKTOK_V2_AUTH } from 'api/auth/mutations';
// Types
import {
  TiktokV2Auth,
  TiktokV2AuthVariables,
} from 'api/auth/types/TiktokV2Auth';
// Helpers
import { getEnvLink } from 'helpers/routes';
// Hooks
import { useAppContext, useGetCurrUser, useSocialAuth } from 'hooks';
// Ui
import FourDotsLoader from 'ui/FourDotsLoader/FourDotsLoader';

const TiktokSdkWatcher = (): null | JSX.Element => {
  const { token } = useAppContext();
  const { handleSocialAuthResponse, handleSocialAuthError } = useSocialAuth();
  const { data: userData } = useGetCurrUser();
  const { query } = useRouter();
  const [loading, setLoading] = useState<boolean>(false);

  const [tiktoAuth] = useMutation<TiktokV2Auth, TiktokV2AuthVariables>(
    TIKTOK_V2_AUTH
  );

  const code = query.code ? decodeURIComponent(query.code as string) : null;

  useEffect(() => {
    const isLoggedIn = !!token?.accessToken || !!userData?.me?.id;

    if (code && !isLoggedIn) {
      setLoading(true);

      const login = async (): Promise<void> => {
        try {
          const { data } = await tiktoAuth({
            variables: {
              input: {
                code,
                redirectUrl: getEnvLink(),
              },
            },
          });

          if (data?.tiktokV2Auth) {
            await handleSocialAuthResponse(data.tiktokV2Auth);
          }
        } catch (error) {
          handleSocialAuthError(error, 'TikTok');
        }

        setLoading(false);
      };

      login();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code, token]);

  if (loading) {
    return <FourDotsLoader />;
  }

  return null;
};

export default TiktokSdkWatcher;
